export default __webpack_public_path__ + "static/logo-dooit-6766b77e6258a62121925cbf37c0bb7e.webp";